import { render } from "./CloserController.vue?vue&type=template&id=ba79f938&scoped=true&ts=true"
import script from "./CloserController.vue?vue&type=script&lang=ts"
export * from "./CloserController.vue?vue&type=script&lang=ts"

import "./CloserController.vue?vue&type=style&index=0&id=ba79f938&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba79f938"]])

export default __exports__